import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';
import {
  EntityLabel,
  ReasonLabel,
  SentimentLabel,
} from 'v2/core/entities/feedback/labels';

export const getFeedbackLabels = (feedbackLabels?: FeedbackLabel[]) => {
  return (
    (feedbackLabels ?? []).reduce(
      (
        acc: {
          entityLabels: EntityLabel[];
          reasonLabels: ReasonLabel[];
          sentimentLabels: SentimentLabel[];
        },
        label: FeedbackLabel,
      ) => {
        switch (label.type) {
          case FeedbackLabelType.Entity:
            return { ...acc, entityLabels: [...acc.entityLabels, label] };
          case FeedbackLabelType.Reason:
            return { ...acc, reasonLabels: [...acc.reasonLabels, label] };
          case FeedbackLabelType.Sentiment:
            return {
              ...acc,
              sentimentLabels: [...acc.sentimentLabels, label],
            };
        }
        return acc;
      },
      {
        entityLabels: [],
        reasonLabels: [],
        sentimentLabels: [],
      },
    ) ?? []
  );
};
